module.exports = __webpack_public_path__ + "static/media/Chongyun.d0accc60.png";